"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _ = require("lodash");
var _1 = require(".");
var element_1 = require("../element");
var __1 = require("..");
var utils_1 = require("../template/utils");
var HorizonChart = /** @class */ (function (_super) {
    __extends(HorizonChart, _super);
    function HorizonChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizonChart.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_bandNumber":
            case "_yMax":
            case "_baseLine":
                return utils_1.parseNumberWithAuto(value);
            case "_isMirror":
                return utils_1.parseBoolean(value);
            case "_valueFunc":
            case "_titleFunc":
                return utils_1.parseFunc(value);
            case "_schemes":
                return utils_1.parseJSON(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    HorizonChart.prototype.defaultOptions = function () {
        return {
            _bandNumber: 3,
            _isMirror: true,
            _valueFunc: function (d) { return d; },
            _yMax: null,
            _baseLine: 0,
            _titleFunc: function (_, i) { return "Subgraph " + (i + 1); },
            _schemes: ["#DB7676", "#91CEEC"],
        };
    };
    HorizonChart.prototype.init = function () {
        var _this = this;
        this._scaleX = d3.scaleLinear();
        this._scaleY = d3.scaleLinear();
        var scaleY = d3.scaleIdentity();
        this._subgraphs = this.appendGroupT(_1.Component).data([]).options({
            _y: function (_, i) { return i * _this._height; },
        });
        this._grids = this._subgraphs.appendT(element_1.Line).options({
            x1: 0,
            x2: function (_) { return _this._cachedWidth; },
            y1: function (_) { return _this._height; },
            y2: function (_) { return _this._height; },
            stroke: "white",
        });
        this._bands = this._subgraphs.appendGroupT(_1.Component).data([]).options({
            _data: function (d) { return d; },
            class: function (_, i) { return "band" + i; },
            opacity: function (_, i) { return (i + 1) / _this._bandNumber; },
        });
        this._groups = this._bands.appendGroupT(_1.Component).data([]).options({
            _data: function (d) { return d; },
            class: function (_, i) { return i === 1 ? "negative" : "positive"; },
        });
        this._areas = this._groups.appendT(element_1.Area).options({
            _scaleX: this._scaleX,
            _scaleY: scaleY,
            fill: function (_, i) { return _this._schemes[i]; },
        });
        this._titles = this._subgraphs.appendT(element_1.Text).options({
            _y: function (_) { return _this._height / 2; },
            _anchor: 4 /* Middle */ | 16 /* Left */,
            _text: function (_, i) { return _this._titleArr[i]; },
            fill: "white",
        });
    };
    HorizonChart.prototype.postOptionsUpdate = function () {
        this._yMax = this.getOption("_yMax");
        this._valueFunc = this.getOption("_valueFunc");
        this._bandNumber = this.getOption("_bandNumber");
        this._baseLine = this.getOption("_baseLine");
        this._isMirror = this.getOption("_isMirror");
        this._titleFunc = this.getOption("_titleFunc");
        this._schemes = this.getOption("_schemes");
    };
    HorizonChart.prototype.prepare = function () {
        var _this = this;
        var cachedHeight = this._getGeometry("_height", false);
        this._cachedWidth = this._getGeometry("_width", true);
        // Get the maximun and minimun of the whold data set
        if (!this._yMax) {
            var max = d3.max(this.datum, function (d) { return d3.max(d, function (obj) { return _this._valueFunc(obj) - _this._baseLine; }); });
            var min = d3.min(this.datum, function (d) { return d3.min(d, function (obj) { return _this._valueFunc(obj) - _this._baseLine; }); });
            this._yMax = d3.max([Math.abs(max), Math.abs(min)]);
        }
        // The height of each area chart
        this._height = cachedHeight / this.datum.length;
        this._scaleY.domain([this._baseLine, this._yMax]).nice()
            .range([this._height * this._bandNumber, 0]);
        this._scaleX.domain([0, this.datum[0].length - 1])
            .range([0, this._cachedWidth]);
        // Get the titles for this._titles
        this._titleArr = this.datum.map(function (d, i) { return _this._titleFunc(d, i); });
        // Transform data to fit the data type of ComplexArea
        var data = this.datum.map(function (d) {
            return _.range(_this._bandNumber).map(function (i) {
                var pos = [];
                var neg = [];
                d.forEach(function (o) {
                    var value = _this._valueFunc(o);
                    if (value >= 0) {
                        if (_this._isMirror) {
                            neg.push([_this._height, _this._height]);
                        }
                        else {
                            neg.push([0, 0]);
                        }
                        var y = _this._scaleY(value);
                        var actualY = _this._height * _this._bandNumber - y;
                        var band = Math.floor(actualY / _this._height);
                        if (band < i) {
                            pos.push([_this._height, _this._height]);
                        }
                        else if (band > i) {
                            pos.push([_this._height, 0]);
                        }
                        else {
                            pos.push([_this._height, y % _this._height]);
                        }
                    }
                    else {
                        pos.push([_this._height, _this._height]);
                        var y = _this._scaleY(Math.abs(value));
                        var actualY = _this._height * _this._bandNumber - y;
                        var band = Math.floor(actualY / _this._height);
                        var height = band === i ? y % _this._height : (band > i ? 0 : _this._height);
                        if (_this._isMirror) {
                            neg.push([_this._height, height]);
                        }
                        else {
                            neg.push([0, _this._height - height]);
                        }
                    }
                });
                return [pos, neg];
            });
        });
        this._subgraphs.data(data);
        this.setupProxy({
            grid: "_grids",
            area: "_areas",
            title: "_titles",
            topAxis: function (axis) {
                axis.options({
                    _scale: _this._scaleX,
                    _gravity: __1.Gravity.Top,
                });
            },
            bottomAxis: function (axis) {
                axis.options({
                    _scale: _this._scaleX,
                    _gravity: __1.Gravity.Bottom,
                    _y: cachedHeight,
                });
            },
        });
    };
    return HorizonChart;
}(_1.Component));
exports.HorizonChart = HorizonChart;
//# sourceMappingURL=horizon-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/horizon-chart.js
// module id = 1162
// module chunks = 0 1